import { Component, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { PastHealthHistory, PastHealthHistoryObj } from '../../../core/models/patient/PastHealthHostoryQuestions';
import { Patient } from '../../../core/models/patient/patient';
import { PatientHealthHistory } from '../../../core/models/patient/PatientHealthHistory';
import { patientHealthSubType, patientHealthType } from '../../../core/models/patient/patientHealthType';
import { PatientService } from '../../../core/services/v2/patient.service';
import { WindowLoaderService } from '../../../shared/components/window-loader/window-loader.service';
import * as _ from 'lodash';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { AppDateAdapter, APP_DATE_FORMATS } from '../../../core/format-datepicker';
import { debug } from 'util';
import { MatSnackBar } from '@angular/material';

@Component({
  selector: 'app-patient-immunizations-history',
  templateUrl: './patient-immunizations-history.component.html',
  styleUrls: ['./patient-immunizations-history.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: AppDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS }
  ]
})
export class PatientImmunizationsHistoryComponent implements OnChanges {
  @Input() editEnable: boolean;
  @Input() patientProfile: Patient;
  @Input() patientHealthHistories: PatientHealthHistory[];
  @Input() patientHealthTypes: patientHealthType[];
  @Input() healthHistoryQuestions: PastHealthHistory[];
  @ViewChild('#patientAllergyForm', null) patientAllergyForm: NgForm;
  pastHistoryStaticQuestions: PastHealthHistory[];
  newQuestionSetForAdd: any;

  patientHealthSubTypes: patientHealthSubType[];
  pastHealthHistoryObj: PastHealthHistoryObj[];
  showAddButton: boolean = true;
  reportImageUrl: string;
  maxDate = new Date();
  constructor(private patientService: PatientService,
    private loaderService: WindowLoaderService,
    private _snackBar: MatSnackBar) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.healthHistoryQuestions && this.healthHistoryQuestions.length > 0) {
      this.pastHistoryStaticQuestions = this.healthHistoryQuestions.filter(x => x.typeId == 5);
      if (this.patientHealthTypes && this.patientHealthHistories) {
        this.patientHealthSubTypes = this.patientHealthTypes.find(x => x.id == 5).healthSubTypes;
        this.mapPastHealthHistoryObj();
      }
    }
  }

  mapPastHealthHistoryObj() {
    this.pastHealthHistoryObj = [];
    let count = 0;
    for (var value of this.patientHealthSubTypes) {
      let data = null;
      let patientHealthHistoryId: number = 0;
      if (this.patientHealthHistories && this.patientHealthHistories.length > 0) {
        const patientHeathHisory = this.patientHealthHistories.find(x => x.typeId == value.typeId && x.subTypeId == value.id);
        if (patientHeathHisory) {
          patientHealthHistoryId = patientHeathHisory.id;
          const dataString = patientHeathHisory.healthData;
          if (dataString && dataString != '') {
            data = JSON.parse(dataString);
          }
        }
      }
      let dataAvailable = "No";
      let dataCount = 0;
      if (patientHealthHistoryId > 0) {
        dataAvailable = "Yes";
        dataCount = data.length;
      }
      let showData = count == 0 ? true : false;

      this.pastHealthHistoryObj.push({ patientHealthHistoryId: patientHealthHistoryId, dataAvailable: dataAvailable, typeId: value.typeId, subTypeId: value.id, subTypeName: value.name, healthData: data, showData: showData, dataCount });
      count++;
    }
  }

  saveDiseaseData(healthHistory: PastHealthHistoryObj, subTypeIndex: number) {
    let addedData = this.convertRequiredJSON(this.newQuestionSetForAdd);
    if (!addedData) { return; }
    healthHistory = this.updateExistingData(healthHistory, addedData);
    console.log('healthHistory data ->', healthHistory);
    const healthData = JSON.stringify(healthHistory.healthData);
    const PatientHealthHistoryData: PatientHealthHistory[] = [{
      id: healthHistory.patientHealthHistoryId,
      patientId: this.patientProfile.id,
      typeId: healthHistory.typeId,
      subTypeId: healthHistory.subTypeId,
      healthData: healthData,
      subTypeName: null,
      typeName: null,
      active: true
    }];
    this.loaderService.blockWithLoader(this.patientService.savePatientHealthHistoryData(PatientHealthHistoryData)).subscribe(
      (details) => {
        if (details.isSuccess) {
          let data = this.pastHealthHistoryObj[subTypeIndex];
          data.dataAvailable = "Yes";
          data.dataCount = data.healthData.length;
          this.pastHealthHistoryObj[subTypeIndex] = data;
          this.showButton();
        }
      },
      (error) => { console.error(error); }
    );
  }

  convertRequiredJSON(item: any) {
    var obj = null;
    const immunization = item.find(
      (innerItem) => innerItem.label === "Immunization"
    );
    if (immunization) {
      const immunValue = immunization.ans;
      if (!immunValue || immunization === '') {
        this._snackBar.open("Immunization field is mandatory", 'Ok', { duration: 5 * 1000 });
        return null;
      }
      const dynamicFields = item.filter(
        (innerItem) => innerItem.label !== "Immunization"
      );
      obj = {
        immun: immunValue,
        arr: [],
      };
      const dynamicObj = {};
      let errorMes = '';
      dynamicFields.forEach((field) => {
        if ((!field.ans || field.ans === '') && field.label != 'Upload your report') {          
          errorMes = `${field.label} field is mandatory`;
        }
        dynamicObj[field.label] = field.ans;
      });
      if (errorMes != '') {
        this._snackBar.open(errorMes, 'Ok', { duration: 5 * 1000 });
        return null;
      }
      obj.arr.push(dynamicObj);
    }
    return obj;
  };

  updateExistingData(healthHistory: PastHealthHistoryObj, addedData: any) {
    if (healthHistory.healthData && healthHistory.healthData.length > 0) {
      const existingIndex = healthHistory.healthData.findIndex(item => item.immun === addedData.immun);

      // If existing data is found, append the new object to the "arr" property
      if (existingIndex !== -1) {
        healthHistory.healthData[existingIndex].arr.push(addedData.arr[0]);
      }
      else {
        healthHistory.healthData.push(addedData);
      }
    }
    else {
      healthHistory.healthData = [];
      healthHistory.healthData.push(addedData);
    }
    return healthHistory;
  }

  toggleCard(collapseCard: HTMLElement) {
    if (collapseCard.classList.contains('active')) {
      collapseCard.classList.remove('active');
    }
    else {
      collapseCard.classList.add('active');
    }
  }

  showForm(subTypeId: number) {
    this.newQuestionSetForAdd = _.cloneDeep(this.pastHistoryStaticQuestions.find(x => x.subTypeId == subTypeId).data[0].qArr[0].inner);
    this.showAddButton = false;
  }

  attachReport(event, index: any, healthHistory: PastHealthHistoryObj) {
    if (event.target.files && event.target.files[0]) {

      const file = event.target.files[0];

      if (!file.type.includes("image")) {
        alert('Please attach only Image file');
        return;
      }

      let patientReportFileForm = new FormData();
      patientReportFileForm.append('PatientId', this.patientProfile.id.toString());
      patientReportFileForm.append('ReportImageSource', file);
      patientReportFileForm.append('SubTypeName', 'Immunization_' + healthHistory.subTypeName.replace(' ', ''));

      this.loaderService.blockWithLoader(this.patientService.uploadPatientMedicalHistoryReport(patientReportFileForm)).subscribe(
        (details) => {
          if (details.resultStatus.isSuccess) {
            this.newQuestionSetForAdd[index].ans = details.result;
          }
        },
        (error) => { console.error(error); this.loaderService.hide(); }
      );
    }
  }

  showButton() {
    this.showAddButton = true;
  }

  setImageUrl(imageUrl:string) {
    this.reportImageUrl = imageUrl;
  }
}
